import { contactContent } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl border border-background-200/70 p-8 md:p-10 text-center">
            <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-send-line text-primary-500 text-2xl"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              {contactContent.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto">
              {contactContent.desc}
            </p>

            <div className="flex flex-wrap justify-center gap-2 mb-6">
              {contactContent.features.map((f) => (
                <span
                  key={f}
                  className="px-3 py-1.5 rounded-lg bg-secondary-100 text-secondary-700 text-xs font-medium"
                >
                  {f}
                </span>
              ))}
            </div>

            <a
              href={`mailto:${contactContent.email}`}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              发送邮件联系
            </a>

            <p className="mt-4 text-xs text-foreground-400">{contactContent.email}</p>
          </div>
        </div>
      </div>
    </section>
  );
}